export default "__VITE_ASSET__BoDhtNIo__"